import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcb92928"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "message position-relative" }
const _hoisted_3 = { class: "mx-2 text-nowrap" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye-slash cursor-pointer" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "submenu" }

import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Avatar from '@/components/avatar'
import Submenu from '@/components/submenu/index.vue'
import { translate } from '@/languages/i18n'
import { computed, ComputedRef, PropType } from 'vue-demi'
import { useStore } from 'vuex'
import { CHAT_STORE } from '@/store/constants'
import relativeTime from 'dayjs/plugin/relativeTime'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import { useRoute, useRouter } from 'vue-router'
import { ChangeTime } from '@/constants/datepicker.ts'
import TargetTag from '@/components/target-tag/index.vue'
import { onMounted, ref, watch } from 'vue'
import { ChatStateTypes } from '@/store/modules/chat'


export default /*#__PURE__*/_defineComponent({
  props: {
  source: {
    type: Object,
    default: null,
  },
  partner_post: {
    type: Object as PropType<{ partner_avatar_url: string; partner_display_name: string; partner_user_type: 'alumni' | 'employee' | 'admin' | 1 | 2 | 3 }>,
  },
  users: {
    type: Object,
  },
  id_comment: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

dayjs.locale('ja')

dayjs.extend(relativeTime)


const route = useRoute()
const router = useRouter()
const store = useStore()
const talk_room_data = computed<ComputedRef<Pick<ChatStateTypes, 'talk_room'>>>(() => store.getters[CHAT_STORE.GETTERS.TALK_ROOM])
const page = computed(() => store.getters[CHAT_STORE.GETTERS.PAGE_CHAT])
const observer = ref()
const first_chat_talk_rooms = ref<HTMLElement>()
const isSubmenuOpen = ref(false)

const menu = computed(() => {
  if (!checkChatBelongLoggedInUser.value) return [null, { title: translate('keepConversationsPrivate'), icon: '' }]

  return [null, { title: translate('SO65delete') }]
})
const menuPrivate = computed(() => {
  const talkroom_route = `/community/communities/${route.params?.id}/admin/groups/${route.params?.group_id}/talkrooms/${route.params?.talkroom_id}`
  const message = talkroom_route.includes(route.path) ? translate('publicYourTalk') : translate('keepPublic')
  if (!checkChatBelongLoggedInUser.value) return [null, { title: message, icon: '' }]

  return [null, { title: translate('SO65delete') }]
})

const dataBs = computed(() => {
  const modal = props.source.published ? '#modalUpdateStatusChatPrivate' : '#modalUpdateStatusChatPublic'
  if (!checkChatBelongLoggedInUser.value) return [['modal', modal]]
  return [['modal', '#deleteChat']]
})

const getData = (page: number) => {
  store.dispatch(CHAT_STORE.ACTIONS.GET_TALK_ROOM, {
    id: route.params?.talkroom_id,
    params: {
      ...(page && { page }),
      create_by_admin: true,
    },
  })
}

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      if (!talk_room_data.value || page.value >= talk_room_data.value?.talk_room?.total_pages) return
      store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT)
      getData(page.value)
    }
  })

  if (first_chat_talk_rooms.value) {
    observer?.value?.observe(first_chat_talk_rooms.value)
  }
})

watch(
  () => first_chat_talk_rooms.value,
  () => {
    if (first_chat_talk_rooms.value) {
      observer?.value?.observe(first_chat_talk_rooms.value)
    }
  }
)

const checkChatBelongLoggedInUser = computed(() => {
  if (route.path.includes('admin')) return props.source.user_type === 'community_admin'

  return props.source.user_type !== 'community_admin'
})

const setCurrentMessage = (): void => {
  store.dispatch(CHAT_STORE.ACTIONS.SET_MESSAGE_ID, props.source.id)
}

const setSubmenuVisibility = (isOpen: boolean): void => {
  isSubmenuOpen.value = isOpen
}

const TransitOE = (user_type: string | number, is_deleted_in_30_days: number, management_no: string) => {
  if (is_deleted_in_30_days !== 2 && user_type !== 'community_admin') {
    if (user_type === 'alumni') {
      router.push(`/community/communities/${route.params?.id}/alumnus/${management_no}/edit`)
    } else {
      router.push(`/community/communities/${route.params?.id}/community-users/${management_no}/edit`)
    }
  }
}

const ReplayName = (
  is_deleted_in_30_days: string | number,
  available: boolean,
  family_name: string,
  given_name: string,
  user_type,
  management_no: string,
  display_name: string
) => {
  if (!is_deleted_in_30_days) {
    if (!available) {
      if ([2, 'alumni'].includes(user_type) && display_name) {
        return management_no + ' ' + family_name + ' ' + given_name + ' ' + '[一時停止]' + `（${display_name}）`
      }
      return management_no + ' ' + family_name + ' ' + given_name + ' ' + '[一時停止]'
    } else {
      if ([2, 'alumni'].includes(user_type) && display_name) {
        return management_no + ' ' + family_name + ' ' + given_name + ' ' + `（${display_name}）`
      }
      return management_no + ' ' + family_name + ' ' + given_name
    }
  } else if (is_deleted_in_30_days === 1 && ([1, 2].includes(user_type) || ['alumni', 'employee'].includes(user_type))) {
    if ([2, 'alumni'].includes(user_type) && display_name) {
      return management_no + ' ' + family_name + ' ' + given_name + ' ' + '[脱退済み]' + `（${display_name}）`
    }
    return management_no + ' ' + family_name + ' ' + given_name + ' ' + '[脱退済み]'
  } else if (is_deleted_in_30_days === 2 && ([1, 2].includes(user_type) || ['alumni', 'employee'].includes(user_type))) {
    return management_no + ' ' + '脱退済みユーザ'
  } else {
    if ([2, 'alumni'].includes(user_type) && display_name) {
      return management_no + ' ' + family_name + ' ' + given_name + ' ' + `（${display_name}）`
    }
    return management_no + ' ' + family_name + ' ' + given_name
  }
}

const time = ref(ChangeTime(props?.source?.created_at))
const changTimeCurrent = (created_at) => {
  const newTime = dayjs(created_at).format('YYYY/MM/DD HH:mm:ss')
  const date = dayjs(new Date())
  const second = date.diff(dayjs(newTime), 'second')
  if (second < 60) {
    setInterval(function () {
      time.value = ChangeTime(created_at)
    }, 1000)
  } else if (second > 60 && second < 3600) {
    setInterval(function () {
      time.value = ChangeTime(created_at)
    }, 60000)
  } else {
    clearInterval()
  }
  return time.value
}

return (_ctx: any,_cache: any) => {
  return (__props.source?.id === 'first_chat_page')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: (_value, _refs) => {
          _refs['first_chat_talk_rooms'] = _value
          first_chat_talk_rooms.value = _value
        }
      }, null, 512))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        id: __props.source?.id,
        class: _normalizeClass(['pb-4 d-flex', _unref(checkChatBelongLoggedInUser) ? 'revert' : '', isSubmenuOpen.value ? 'submenu-open' : ''])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['comment__avatar d-flex', !__props.source.published ? 'blur' : ''])
        }, [
          _createVNode(_unref(Avatar), {
            is_deleted_in_30_days: __props.source?.is_deleted_in_30_days,
            user_image_url: __props.source.user_image_url,
            userType: __props.source?.user_type
          }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
        ], 2),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(['d-flex justify-content-between w-100 mb-2', _unref(checkChatBelongLoggedInUser) ? 'revert' : '', !__props.source.published ? 'blur' : ''])
          }, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (TransitOE(__props.source?.user_type, __props.source?.is_deleted_in_30_days, __props.source?.management_no))),
              class: "cursor-pointer"
            }, [
              (__props.source?.user_type !== 'community_admin')
                ? (_openBlock(), _createBlock(UserAliasIcon, {
                    key: 0,
                    title: 
              ReplayName(__props.source?.is_deleted_in_30_days, __props.source?.available, __props.source?.family_name, __props.source?.given_name, __props.source?.user_type, __props.source?.management_no, __props.source?.display_name)
            ,
                    userType: __props.source?.user_type
                  }, null, 8, ["title", "userType"]))
                : (_openBlock(), _createBlock(UserAliasIcon, {
                    key: 1,
                    title: __props.source?.family_name + ' ' + __props.source?.given_name,
                    userType: __props.source?.user_type
                  }, null, 8, ["title", "userType"]))
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(['fs-8 d-flex', _unref(checkChatBelongLoggedInUser) ? 'revert' : ''])
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(changTimeCurrent(__props.source?.created_at)), 1),
              (!__props.source.published)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                : _createCommentVNode("", true)
            ], 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(['mx-auto comment__content px-4 py-3 w-100 position-relative text', !__props.source.published ? 'blur' : '', __props.source?.id === __props.id_comment ? 'message-highlight' : ''])
          }, [
            _createVNode(TargetTag, {
              data: __props.source?.content,
              users: __props.users
            }, null, 8, ["data", "users"])
          ], 2),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Submenu, {
              revert: !_unref(checkChatBelongLoggedInUser),
              menu: !__props.source.published ? _unref(menuPrivate) : _unref(menu),
              dataBs: _unref(dataBs),
              onClick: setCurrentMessage,
              onMenuVisibilityChange: setSubmenuVisibility
            }, null, 8, ["revert", "menu", "dataBs"])
          ])
        ])
      ], 10, _hoisted_1))
}
}

})